module.exports = __webpack_public_path__ + "static/media/snackbar_v2_copied.587b0983.svg";